import React from "react";
import WarehouseList from "../components/warehouses/WarehouseList";

const Warehouses: React.FC = () => {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">
        Gestione Magazzini
      </h1>
      <WarehouseList />
    </div>
  );
};

export default Warehouses;
